import { appendUrlParam } from './appendUrlParam'
import escapeHtml from './escapeHtml'
import React from 'react'
import { createRoot } from 'react-dom/client'
import StartCheckout from './billing/StartCheckout'
import UpgradeOrganization from './billing/UpgradeOrganization'
import UpgradeProject from './billing/UpgradeProject'
import ChangePlan from './billing/ChangePlan'
import Raven from 'raven-js'
import key from 'keymaster'

var disabledStateChangeDuringHistoryHack = false

// data-load-into
//     1: ./Bundle/AlertBundle/Resources/views/Incident/list.html.twig
//     1: ./Bundle/BillingBundle/Resources/views/Admin/listSubscriptions.html.twig
//     1: ./Bundle/ProfilerBundle/Resources/views/Transaction/recentProfiles.html.twig
//     1: ./Bundle/OrganizationBundle/Resources/views/GithubTeam/selectOrganizations.html.twig
//     1: ./Bundle/OrganizationBundle/Resources/views/GithubTeam/selectTeams.html.twig
//     1: ./Bundle/OrganizationBundle/Resources/views/Admin/listUsers.html.twig
jQuery.fn.loadInto = function(options) {
    jQuery(this).each(function(idx, element) {
        if (
            $(element)
                .attr('href')
                .indexOf('http') == 0
        ) {
            return
        }

        var loadInto = $(element).data('load-into') || options.element
        if ($(loadInto).length == 0) {
            return
        }

        $(element).on('click', function(ev) {
            // middle-mouse button
            if (ev.button == 1) {
                return
            }

            ev.preventDefault()

            var pageMode = $(element).data('load-into-mode') || (options && options.pageMode) || 'central-side'

            // @HACK: Since we are using a react integrated history and this
            // history the statechange event is not fired in case of:
            //
            // * jQuery: /url1
            // * React:  /url2 … /url23
            // * jQuery: /url1
            //
            // In this case this History thinks it is still at the same entry
            // and does not fire a statechange event (which makes sense).
            //
            // We test if the URL History.js thinks is current actually does
            // equal the current location (which could be changed by
            // React-Router). If this is not the case we replace the current
            // state so that the following pushState will trigger a statechange
            // event.
            var State = History.getState()
            if (State.url !== window.location.href) {
                disabledStateChangeDuringHistoryHack = true
                History.replaceState({}, document.title, window.location.href)
                disabledStateChangeDuringHistoryHack = false
            }

            History.pushState({ slideElement: loadInto, effect: false, pageMode: pageMode }, document.title, $(element).attr('href'))
        })
    })
}

jQuery.fn.hotkey = function(options) {
    return $(this).each(function(idx, item) {
        key($(item).data('hotkey'), function(ev) {
            ev.preventDefault()
            $(item).trigger('click')
        })
    })
}

// data-typeahead
//     1: ./Bundle/ProfilerBundle/Resources/views/Transaction/typeahead.html.twig
jQuery.fn.operationTypeahead = function(options) {
    return $(this).each(function(idx, item) {
        var bloodhound = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: $(item).data('typeahead') + '?s=%QUERY',
                filter: function(response) {
                    return response.operations
                },
            },
        })

        bloodhound.initialize()

        var hiddenId = $('<input type="hidden" name="op_id" value="" />')
        hiddenId.insertAfter(item)

        $(item)
            .typeahead(null, {
                name: 'operations',
                displayKey: 'name',
                source: bloodhound.ttAdapter(),
                templates: {
                    suggestion: function(context) {
                        return '<div class="row"><div class="col-lg-12">' + context.name + '</div></div>'
                    },
                },
            })
            .on('typeahead:selected', function(ev, suggestion, dataset) {
                hiddenId.val(suggestion.id)
                // $(item).parents('form').submit();
            })
            .on('keypress', function(ev) {
                if (ev.keyCode == 13) {
                    ev.stopPropagation()
                }
            })
    })
}

// data-radio-collapse
//     1: ./Bundle/AlertBundle/Resources/views/ActionConfiguration/editAction.html.twig
//     1: ./Bundle/AlertBundle/Resources/views/ActionConfiguration/createActionForm.html.twig
jQuery.fn.radioCollapse = function(options) {
    return $(this).each(function(idx, item) {
        const $radios = $(item).find('input[type=radio]')

        const changeTrigger = function() {
            const radio = this

            $radios.each(function(idx, otherRadio) {
                if (otherRadio !== radio) {
                    var closeSelector = $(otherRadio).attr('data-target')
                    if (closeSelector) {
                        $(closeSelector).collapse('hide')
                    }
                }
            })

            const openSelector = $(radio).attr('data-target')
            if (openSelector) {
                $(openSelector).collapse('show')
            }
        }

        $radios.on('change', changeTrigger)
        $radios.filter(':checked').trigger('change')
    })
}

// data-fancy-checkbox
//     1: ./Bundle/AlertBundle/Resources/views/Configuration/check-actions.html.twig
jQuery.fn.fancyCheckbox = function(options) {
    return $(this).each(function(idx, checkboxDiv) {
        var $originalCheckbox = $(checkboxDiv).find('input[type="checkbox"]')

        var $checkboxButton = $(
            '<button class="btn btn-sm btn-flat btn-block"><i class="fa ' +
                $(checkboxDiv).data('fancy-checkbox-icon') +
                '"> ' +
                $(checkboxDiv).attr('title') +
                '</button>',
        )

        var updateButtonColor = function(checkbox) {
            if ($(checkbox).attr('checked')) {
                $checkboxButton.removeClass('btn-default')
                $checkboxButton.addClass('bg-olive')
            } else {
                $checkboxButton.addClass('btn-default')
                $checkboxButton.removeClass('bg-olive')
            }
        }

        $checkboxButton.on('click', function(e) {
            e.preventDefault()
            $originalCheckbox.attr('checked', !$originalCheckbox.attr('checked'))
            updateButtonColor($originalCheckbox)
        })

        updateButtonColor($originalCheckbox)

        $(checkboxDiv).after($('<div class="form-group"></div>').append($checkboxButton))
    })
}

// data-validate-slug
//     2: ./Bundle/OrganizationBundle/Resources/views/Organization/create.html.twig
//     1: ./Bundle/OrganizationBundle/Resources/views/Application/create.html.twig
jQuery.fn.validateSlug = function(options) {
    return jQuery(this).each(function(idx, element) {
        var $el = $(this),
            $formGroup = $el.closest('.form-group')

        $el.on('keyup blur', function() {
            var name = $el.val()

            if (name.length == 0) {
                $formGroup.removeClass('has-error').removeClass('has-success')
            } else if (!name.match(/^([A-Za-z0-9_\.-]+)$/)) {
                $formGroup.addClass('has-error').removeClass('has-success')
            } else {
                $formGroup.removeClass('has-error').addClass('has-success')
            }
        })
    })
}

$(function() {
    'use strict'

    //Add hover support for touch devices
    $('.btn')
        .bind('touchstart', function() {
            $(this).addClass('hover')
        })
        .bind('touchend', function() {
            $(this).removeClass('hover')
        })

    //Activate tooltips
    $("[data-toggle='tooltip']").tooltip()

    /*
     * Add collapse and remove events to boxes
     */
    $("[data-widget='collapse']").click(function() {
        //Find the box parent
        var box = $(this)
            .parents('.box')
            .first()
        //Find the body and the footer
        var bf = box.find('.box-body, .box-footer')
        if (!box.hasClass('collapsed-box')) {
            box.addClass('collapsed-box')
            bf.slideUp()
        } else {
            box.removeClass('collapsed-box')
            bf.slideDown()
        }
    })

    /*
     * INITIALIZE BUTTON TOGGLE
     * ------------------------
     */
    $("[data-widget='remove']").click(function() {
        //Find the box parent
        var box = $(this)
            .parents('.box')
            .first()
        box.slideUp()
    })
})

function bootstrapTabsEnableHistoryJs(element) {
    $(element)
        .find("a[data-toggle='tab']")
        .on('shown.bs.tab', function(e) {
            var url = $(e.delegateTarget).attr('href')
            var tabName = $(e.delegateTarget).data('target')

            $(element)
                .find('ul.nav-tabs a[data-target="' + tabName + '"]')
                .parent()
                .removeClass('hidden')

            if (url.substr(0, 1) != '#') {
                // using data-target and an url!
                History.pushState(
                    {
                        tab: tabName,
                        remoteTab: typeof $(e.delegateTarget).data('remote') !== 'undefined',
                    },
                    document.title,
                    url,
                )
            }
        })
}

function initEvents(element) {
    // data-moments-ago
    //     2: ./Bundle/OrganizationBundle/Resources/views/Admin/listUsers.html.twig
    //     2: ./Bundle/OrganizationBundle/Resources/views/Admin/showOrganization.html.twig
    //     2: ./Bundle/OrganizationBundle/Resources/views/Admin/user.html.twig
    //     2: ./Bundle/OrganizationBundle/Resources/views/Admin/listActivity.html.twig
    //     1: ./Bundle/ProfilerBundle/Resources/views/Environment/list.html.twig
    //     1: ./Bundle/ProfilerBundle/Resources/views/Transaction/list.html.twig
    //     1: ./Bundle/ProfilerBundle/Resources/views/Transaction/recentProfiles.html.twig
    //     1: ./Bundle/OrganizationBundle/Resources/views/Admin/features.html.twig
    //     1: ./Bundle/OrganizationBundle/Resources/views/Admin/showApplication.html.twig
    $(element)
        .find('[data-moments-ago]')
        .each(function(idx, element) {
            var date = $(element).text()
            var format = $(element).data('moments-ago') || 'YYYY-MM-DD HH:mm:ss'
            var m = moment.utc(date, format).local()
            $(element)
                .text(m.fromNow().replace('a few seconds ago', 'just now'))
                .attr('title', date)
                .tooltip({ delay: 300 })
        })

    // data-local-date
    //     5: ./Bundle/AlertBundle/Resources/views/Incident/view.html.twig
    //     1: ./Bundle/AlertBundle/Resources/views/Incident/list.html.twig
    //     1: ./Bundle/ErrorBundle/Resources/views/Errors/listIgnoredExceptions.html.twig
    $(element)
        .find('[data-local-date]')
        .each(function(idx, element) {
            var format = $(element).data('local-date') || 'DD.MM.YYYY'
            var fromFormat = $(element).data('local-date-from-format') || format
            var date = moment
                .utc($(element).text(), fromFormat)
                .local()
                .format(format)
            $(element).text(date)
        })

    bootstrapTabsEnableHistoryJs(element)

    // data-load-into
    //     1: ./Bundle/AlertBundle/Resources/views/Incident/list.html.twig
    //     1: ./Bundle/BillingBundle/Resources/views/Admin/listSubscriptions.html.twig
    //     1: ./Bundle/ProfilerBundle/Resources/views/Transaction/recentProfiles.html.twig
    //     1: ./Bundle/OrganizationBundle/Resources/views/GithubTeam/selectOrganizations.html.twig
    //     1: ./Bundle/OrganizationBundle/Resources/views/GithubTeam/selectTeams.html.twig
    //     1: ./Bundle/OrganizationBundle/Resources/views/Admin/listUsers.html.twig
    $(element)
        .find('[data-load-into]')
        .loadInto()
    // data-toggle
    //     5: ./Bundle/OrganizationBundle/Resources/views/Partner/index.html.twig
    //     4: ./Bundle/OrganizationBundle/Resources/views/Admin/listOrganizations.html.twig
    //     2: ./Bundle/AlertBundle/Resources/views/Configuration/index.html.twig
    //     2: ./Bundle/BillingBundle/Resources/views/Billing/transfer.html.twig
    //     2: ./Bundle/BillingBundle/Resources/views/Billing/checkout.html.twig
    //     2: ./Bundle/OrganizationBundle/Resources/views/Team/list.html.twig
    //     1: ./Bundle/AlertBundle/Resources/views/Incident/list.html.twig
    //     1: ./Bundle/BillingBundle/Resources/views/Billing/upgrade.html.twig
    //     1: ./Bundle/BillingBundle/Resources/views/Billing/show.html.twig
    //     1: ./Bundle/CoreBundle/Resources/views/secure-layout.html.twig
    //     1: ./Bundle/ProfilerBundle/Resources/views/Environment/list.html.twig
    //     1: ./Bundle/ProfilerBundle/Resources/views/EventApi/herokuHelp.html.twig
    //     1: ./Bundle/OrganizationBundle/Resources/views/Admin/showApplication.html.twig
    $(element)
        .find('[data-toggle="tooltip"]')
        .tooltip()
    // data-typeahead
    //     1: ./Bundle/ProfilerBundle/Resources/views/Transaction/typeahead.html.twig
    $(element)
        .find('[data-typeahead]')
        .operationTypeahead()
    // data-validate-slug
    //     2: ./Bundle/OrganizationBundle/Resources/views/Organization/create.html.twig
    //     1: ./Bundle/OrganizationBundle/Resources/views/Application/create.html.twig
    $(element)
        .find('[data-validate-slug]')
        .validateSlug()
    // data-payment-signup
    //     1: ./Bundle/BillingBundle/Resources/views/Billing/transfer.html.twig
    //     1: ./Bundle/BillingBundle/Resources/views/Billing/checkout.html.twig
    //     1: ./Bundle/BillingBundle/Resources/views/Checkout/checkout.html.twig
    $(element)
        .find('[data-payment-signup]')
        .paymentSignup()
    //data-sepapayment-signup
    //     1: ./Bundle/BillingBundle/Resources/views/Billing/createSepaPayment.html.twig
    $(element)
        .find('[data-sepapayment-signup]')
        .createSepaPayment()
    //data-sepacheckout-signup
    //     1: ./Bundle/BillingBundle/Resources/views/Billing/checkoutSepa.html.twig
    $(element)
        .find('[data-sepacheckout-signup]')
        .SepaCheckout()
    // data-payment-pricing
    //     1: ./Bundle/BillingBundle/Resources/views/Billing/upgradeLicense.html.twig
    //     1: ./Bundle/BillingBundle/Resources/views/Billing/selectLicense.html.twig
    $(element)
        .find('[data-payment-pricing]')
        .paymentPricing()
    $(element)
        .find('[data-payment-tideways6]')
        .paymentTideways6()
    // data-payment-upgrade
    //     1: ./Bundle/BillingBundle/Resources/views/Billing/upgrade.html.twig
    $(element)
        .find('[data-coupon-code]')
        .couponCode()
    // data-remote-modal
    //     2: ./Bundle/ProfilerBundle/Resources/views/Transaction/list.html.twig
    //     1: ./Bundle/AlertBundle/Resources/views/ActionConfiguration/action-view.html.twig
    //     1: ./Bundle/AlertBundle/Resources/views/ActionConfiguration/index.html.twig
    //     1: ./Bundle/AlertBundle/Resources/views/Configuration/viewCheck.html.twig
    //     1: ./Bundle/AlertBundle/Resources/views/Configuration/index.html.twig
    $(element)
        .find('[data-remote-modal]')
        .remoteModal()

    $(element)
        .find('[data-install-selector]')
        .installSelector()
    // data-radio-collapse
    //     1: ./Bundle/AlertBundle/Resources/views/ActionConfiguration/editAction.html.twig
    //     1: ./Bundle/AlertBundle/Resources/views/ActionConfiguration/createActionForm.html.twig
    $(element)
        .find('[data-radio-collapse]')
        .radioCollapse()
    // data-fancy-checkbox
    //     1: ./Bundle/AlertBundle/Resources/views/Configuration/check-actions.html.twig
    $(element)
        .find('[data-fancy-checkbox]')
        .fancyCheckbox()
    // data-retention-url
    //     1: ./Bundle/BillingBundle/Resources/views/Billing/show.html.twig
    $(element)
        .find('[data-retention-url]')
        .applicationRetention()

    $(element)
        .find('[data-traces-waiting]')
        .tracesWaitingList() // data-confirm-submit
    //     6: ./Bundle/BillingBundle/Resources/views/Billing/upgradeLicense.html.twig
    //     3: ./Bundle/BillingBundle/Resources/views/Billing/upgrade.html.twig
    $(element)
        .find('[data-confirm-submit]')
        .confirmSubmitButton()

    $(element)
        .find('[data-radio-row]')
        .radioRow()

    // data-clipboard-copy
    //      1. ./Bundle/OrganizationBundle/Resources/views/Admin/showOrganization.html.twig
    $(element)
        .find('[data-clipboard-copy]')
        .clipboardCopy()

    $(element)
        .find('[data-transaction-selector]')
        .enableChangeVisibilityButton()

    $(element)
        .find('[data-target-visibility]')
        .handleBulkVisibilityChange()

    $(element)
        .find('[data-target-failure-notification-category]')
        .handleBulkFailureNotificationCategoryChange()

    $(element)
        .find('[data-hotkey]')
        .hotkey()

    window.pluginRegistry.activate($(element))

    if (typeof hljs !== 'undefined') {
        $(element)
            .find('pre code')
            .each(function(i, block) {
                hljs.highlightBlock(block)
            })
    }
}

function appendDate(url) {
    return appendUrlParam(url, new Date().getTime())
}

;(function($, jQuery) {
    jQuery.fn.paymentTideways6 = function() {
        return $(this).each(function(idx, el) {
            var $base = $(el)
            var upgradeData = $base.data('payment-tideways6-data')
            var projectId = $base.data('payment-tideways6-projectid')
            var actionUrl = $base.data('payment-tideways6-action-url')
            var csrfToken = $base.data('payment-tideways6-csrf-token')
            var isTrial = $base.data('payment-tideways6-is-trial')
            var isCheckout = $base.data('payment-tideways6-is-checkout')
            var currentPrice = $base.data('payment-tideways6-current-price')

            const root = createRoot($base[0])

            recurly.configure({ publicKey: $base.data('payment-tideways6') })

            if (projectId) {
                return root.render(
                    <UpgradeProject
                        recurlyPricing={recurly.Pricing()}
                        upgrade={upgradeData}
                        projectId={projectId}
                        actionUrl={actionUrl}
                        csrfToken={csrfToken}
                        isTrial={isTrial}
                        isCheckout={isCheckout}
                        currentPrice={currentPrice}
                    />,
                )
            }

            if (actionUrl.endsWith('/start')) {
                return root.render(
                    <StartCheckout recurlyPricing={recurly.Pricing()} upgrade={upgradeData} actionUrl={actionUrl} csrfToken={csrfToken} />,
                )
            }

            if (actionUrl.endsWith('/change-plan')) {
                return root.render(
                    <ChangePlan recurlyPricing={recurly.Pricing()} upgrade={upgradeData} actionUrl={actionUrl} csrfToken={csrfToken} />,
                )
            }

            return root.render(
                <UpgradeOrganization
                    recurlyPricing={recurly.Pricing()}
                    upgrade={upgradeData}
                    actionUrl={actionUrl}
                    csrfToken={csrfToken}
                />,
            )
        })
    }
})(jQuery, jQuery)
;(function($, jQuery) {
    jQuery.fn.couponCode = function(options) {
        options = jQuery.extend({}, jQuery.fn.couponCode.defaults, options)

        return $(this).each(function() {
            var $couponLabel = $(this)
            var code = $(this).data('coupon-code') || options.code

            if (code.length > 0) {
                $(this).html('<i>Looking up coupon...</i>')
                $.ajax({
                    url: '/settings/billing/lookup-coupon?couponCode=' + code,
                    dataType: 'json',
                    success: function(coupon) {
                        $couponLabel.html(escapeHtml(coupon.label))

                        options.onCoupon(coupon, true)
                    },
                    error: function(coupon) {
                        $couponLabel.text('')
                        options.onCoupon(null, false)
                    },
                })
            }
        })
    }
    jQuery.fn.couponCode.defaults = {
        onCoupon: function(foundCoupon, valid) {},
        code: false,
    }
})(jQuery, jQuery)

// data-billing-addon-price
//     6: ./Bundle/BillingBundle/Resources/views/Billing/checkout.html.twig
//     5: ./Bundle/BillingBundle/Resources/views/Billing/upgradeLicense.html.twig
//     5: ./Bundle/BillingBundle/Resources/views/Billing/selectLicense.html.twig
;(function($, jQuery) {
    jQuery.fn.paymentPricing = function(options) {
        options = jQuery.extend({}, jQuery.fn.paymentPricing.defaults, options)

        return $(this).each(function(idx, el) {
            var $base = $(el)
            var recurlyPublicKey = options.recurlyPublicKey || $base.data('payment-pricing')
            var pricing = recurly.Pricing()

            if (options.configureRecurly) {
                recurly.configure({ publicKey: recurlyPublicKey })
            }

            pricing.attach($base[0])

            if (console) {
                pricing.on('error', function(e) {
                    console.error(e)
                })
            }

            var calculate = function() {
                var selectedPlan = $base.find('[data-recurly="plan"]').val()
                pricing = pricing.plan(selectedPlan, { quantity: 1 })

                $base.find('[data-recurly-addon]').each(function(idx, el) {
                    pricing = pricing.addon($(el).data('recurly-addon'), { quantity: parseInt($(el).val(), 10) })
                })

                $base.find('[data-recurly="coupon"]').each(function(idx, el) {
                    pricing = pricing.coupon($(el).val())
                })

                var currency = $base.find('[data-recurly="currency"]').val() || 'EUR'

                var isYearly = selectedPlan.indexOf('_1y') > 0

                pricing
                    .currency(currency)
                    .catch(function(err) {
                        // err.code
                    })
                    .done(function(price) {
                        var subtotal = parseFloat($base.find('[data-recurly="subtotal_now"]:first').html())
                        var total = parseFloat($base.find('[data-recurly="total_now"]:first').html())

                        var taxAmount = ((total - subtotal) / subtotal) * 100
                        var monthlyFee = isYearly ? subtotal / 11 : subtotal

                        $base.find('[data-tax-amount]').html(Math.round(taxAmount))

                        var planLabels = {
                            tideways6_starter: 'Starter',
                            tideways6_basic: 'Basic',
                            tideways6_standard: 'Standard',
                            tideways6_pro: 'Pro',
                            tideways7_basic: 'Basic',
                            tideways7_standard: 'Standard',
                            tideways7_pro: 'Pro',
                        }

                        $base.find('[data-plan-label-show').text(planLabels[selectedPlan.replace('_1y', '')])

                        if (selectedPlan.indexOf('_1y') === -1) {
                            $base.find('.yearly-savings').show()
                        } else {
                            $base.find('.yearly-savings').hide()
                        }
                        $base.find('[data-yearly-savings]').html(Math.round(monthlyFee * 100) / 100)
                        $base.find('[data-billing-price="base_plan"]').text(price.base.plan.unit.replace('.00', ''))
                        $base.find('[data-billing-addon-price]').each(function(idx, el) {
                            var addonName = $(el).data('billing-addon-price')
                            if (typeof price.base.addons[addonName] !== 'undefined') {
                                $(el).text(price.base.addons[addonName].replace('.00', ''))
                            } else {
                                $(el).text('0')
                            }
                        })
                        $base.find('[data-billing-price]').each(function(idx, el) {
                            var priceType = $(el).data('billing-price')
                            if (typeof price.now[priceType] !== 'undefined') {
                                $(el).text(price.now[priceType].replace('.', ','))
                            }
                        })
                        $base.find('[data-billing-timeframely]').text(isYearly ? 'Yearly' : 'Monthly')
                        $base.find('[data-billing-timeframe]').text(isYearly ? 'year' : 'month')
                    })
                    .on('change', state => {
                        var taxAmount = ((state.now.total - state.now.subtotal) / state.now.subtotal) * 100
                        $base.find('[data-tax-amount]').html(Math.round(taxAmount))
                    })
            }

            $base.find('[data-recurly="plan"]').on('change', function(ev) {
                const label = $(this)
                    .find(':selected')
                    .html()
                $(document)
                    .find('[data-plan-label-upgrade]')
                    .text(label)
                calculate()
            })

            $base.find('[data-recurly="currency"]').on('change', function(ev) {
                calculate()
            })
            $base.find('[data-recurly-addon]').each(function(idx, el) {
                $(el).on('change', function(ev) {
                    calculate()
                })
            })

            $('[data-recurly="plan"]').change()

            calculate()
        })
    }
    jQuery.fn.paymentPricing.defaults = {
        recurlyPublicKey: false,
        configureRecurly: true,
        projectId: 0,
    }
})(jQuery, jQuery)

//
// 1: ./Bundle/BillingBundle/Resources/views/Billing/createSepaPayment.html.twig
;(function($, jQuery) {
    jQuery.fn.createSepaPayment = function(options) {
        options = jQuery.extend({}, jQuery.fn.createSepaPayment.defaults, options)

        return $(this).each(function() {
            var $form = $(this)
            var stripePublicKey = $form.data('sepapayment-signup')
            // Create a Stripe client.
            var stripe = Stripe(stripePublicKey)
            // Create an instance of Elements.
            var elements = stripe.elements()
            var errorMessage = document.getElementById('error-message')
            var bankName = document.getElementById('bank-name')
            var clientSecret = $form.data('sepapayment-client-secret')

            var showError = function(message) {
                errorMessage.textContent = 'Error ' + message
                errorMessage.className = 'alert alert-danger alert-dismissable'
                errorMessage.classList.add('visible')
            }

            var removeError = function() {
                errorMessage.className = ''
                errorMessage.textContent = ''
                errorMessage.classList.remove('visible')
            }

            var style = {
                base: {
                    color: '#32325d',
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                    fontSmoothing: 'antialiased',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#aab7c4',
                    },
                    ':-webkit-autofill': {
                        color: '#32325d',
                    },
                },
                invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a',
                    ':-webkit-autofill': {
                        color: '#fa755a',
                    },
                },
            }

            var iban = elements.create('iban', {
                style: style,
                supportedCountries: ['SEPA'],
                placeholderCountry: 'DE',
            })

            // Add an instance of the iban Element into the `iban-element` <div>.
            iban.mount('#iban-element')
            iban.on('change', function(event) {
                // Handle real-time validation errors from the iban Element.
                if (event.error) {
                    showError(event.error.message)
                } else {
                    removeError()
                }
                // Display bank name corresponding to IBAN, if available.
                if (event.bankName) {
                    bankName.textContent = event.bankName
                    bankName.classList.add('visible')
                } else {
                    bankName.classList.remove('visible')
                }
            })

            // Handle form submission.
            var form = document.getElementById('payment-form')
            form.addEventListener('submit', function(event) {
                event.preventDefault()

                var data = {
                    payment_method: {
                        sepa_debit: iban,
                        billing_details: {
                            name: document.querySelector('input[name="sepacheckout[name]"]').value,
                            email: document.querySelector('input[name="sepacheckout[email]"]').value,
                        },
                    },
                }

                stripe.confirmSepaDebitSetup(clientSecret, data).then(function(result) {
                    if (result.error) {
                        showError(result.error.message)
                    } else {
                        removeError()
                        var sepaSetupIntent = result.setupIntent
                        $form.find('#source').val(sepaSetupIntent.payment_method)
                        form.submit()
                    }
                })
            })
        })
    }
    jQuery.fn.createSepaPayment.defaults = {}
})(jQuery, jQuery)
;(function($, jQuery) {
    jQuery.fn.SepaCheckout = function(options) {
        options = jQuery.extend({}, jQuery.fn.SepaCheckout.defaults, options)

        return $(this).each(function() {
            var $form = $(this)
            var recurlyPublicKey = $form.data('sepacheckout-signup')

            var showError = function(message, disableSignup, type) {
                type = type || 'danger'
                disableSignup = disableSignup || false
                var error = $(
                    '<div class="alert alert-' +
                        type +
                        ' alert-dismissable"><i class="fa fa-ban"></i><button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button> <span class="message"></span></div>',
                )

                error.find('.message').text(message)

                $form.find('.errors').html(error)

                var scroll_pos = 0
                $('html, body').animate({ scrollTop: scroll_pos }, '1000')

                $form.find('#signup').attr('disabled', disableSignup)
            }

            $form.paymentPricing({ recurlyPublicKey: recurlyPublicKey })

            $form.css('display', '')
            var $couponCode = $form.find('[data-recurly="coupon"]')
            var validCode = false
            var foundCode = null

            $form.find('[data-coupon-label]').couponCode({
                code: $couponCode.val(),
                onCoupon: function(coupon, valid) {
                    validCode = valid
                    foundCode = coupon
                },
            })

            $form.on('submit', function(ev) {
                var form = this
                ev.target.checkValidity()
                ev.preventDefault()

                $form.find('.has-error').removeClass('has-error')
                var code = $couponCode.val().toLowerCase()
                var country = $form.find('#manual_checkout_country').val()
                var vatRegNo = $form.find('#manual_checkout_vat_number').val()
                var vatCountryCode = vatRegNo.slice(0, 2).toUpperCase()
                var vatnumber = vatRegNo.slice(2)
                var euCountries = [
                    'AT',
                    'BE',
                    'BG',
                    'CY',
                    'CZ',
                    'DK',
                    'EE',
                    'ES',
                    'FI',
                    'FR',
                    'GR',
                    'HR',
                    'HU',
                    'IE',
                    'IT',
                    'LV',
                    'LT',
                    'LU',
                    'MT',
                    'NL',
                    'PT',
                    'RO',
                    'SE',
                    'SI',
                    'SK',
                ]

                // Check if EU customer has VAT Reg No set
                if (euCountries.indexOf(country) != -1 && vatRegNo.trim().length == 0 && code != 'nonprofit19jzu') {
                    showError('As a customer from the European Union you must enter a EU-VAT Registration number.', false)
                    return
                }

                if ((euCountries.indexOf(vatCountryCode) != -1 && vatnumber.trim().length < 8) || vatnumber.trim().length > 12) {
                    showError('The entered EU-VAT Registration number is invalid.', false)
                    return
                }

                if (code.length > 0 && !validCode) {
                    showError('Invalid coupon code given.', false)
                    return
                }

                form.submit()
            })
        })
    }
    jQuery.fn.SepaCheckout.defaults = {}
})(jQuery, jQuery)
;(function($, jQuery) {
    jQuery.fn.paymentSignup = function(options) {
        options = jQuery.extend({}, jQuery.fn.paymentSignup.defaults, options)

        return $(this).each(function() {
            var $form = $(this)
            var recurlyPublicKey = $form.data('payment-signup')

            var showError = function(message, disableSignup, type) {
                disableSignup = disableSignup || false
                type = type || 'danger'
                var error = $(
                    '<div class="alert alert-' +
                        type +
                        ' alert-dismissable"><i class="fa fa-ban"></i><button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button> <span class="message"></span></div>',
                )

                error.find('.message').text(message)

                $form.find('.errors').html(error)

                var scroll_pos = 0
                $('html, body').animate({ scrollTop: scroll_pos }, '1000')

                $form.find('#signup').attr('disabled', disableSignup)
            }

            $form.paymentPricing({ recurlyPublicKey: recurlyPublicKey })

            recurly.configure({
                publicKey: recurlyPublicKey,
                style: {
                    displayIcon: true,
                    all: {
                        fontSize: '16px',
                        lineHeight: '1.42857143',
                        fontColor: '#333333',
                    },
                    number: {
                        placeholder: '',
                    },
                    month: {
                        placeholder: 'mm',
                    },
                    year: {
                        placeholder: 'yy',
                    },
                },
            })

            $form[0].noValidate = true

            // Handling of country states/provinces
            // Currently supporting: United States (US) and Canada (CA)
            // Important: Other countries sometimes get errors, when data-recurly="state" is submitted empty,
            // this must be handled correctly.
            var $countries = $form.find('#country')
            var $usStates = $form.find('#us-states')
            var $stateOptions = $usStates.find('option[data-state-country]')
            var $stateSelect = $usStates.find('select[data-recurly="state"]')

            $countries.on('change', function(ev) {
                var $field = $(ev.delegateTarget)
                var country = $field.val()

                $stateSelect
                    .val('')
                    .html('')
                    .append($stateOptions.filter('[data-state-country="' + country + '"]'))

                if ($stateOptions.filter('[data-state-country="' + country + '"]').length > 0) {
                    $stateSelect.attr('data-recurly', 'state')
                    $usStates.show()
                } else {
                    $stateSelect.removeAttr('data-recurly')
                    $usStates.hide()
                }
            })

            if ($countries.val() == 'US') {
                $stateSelect
                    .val('')
                    .html('')
                    .append($stateOptions.filter('[data-state-country="' + $countries.val() + '"]'))
                if ($stateOptions.filter('[data-state-country="' + $countries.val() + '"]').length > 0) {
                    $stateSelect.attr('data-recurly', 'state')
                    $usStates.show()
                }
            } else {
                $usStates.hide()
            }

            $form.css('display', '')

            var $couponCode = $form.find('[data-recurly="coupon"]')
            var validCode = false
            var foundCode = null

            $form.find('[data-coupon-label]').couponCode({
                code: $couponCode.val(),
                onCoupon: function(coupon, valid) {
                    validCode = valid
                    foundCode = coupon
                },
            })

            $form.on('submit', function(ev) {
                var form = this
                $form.find('#signup').attr('disabled', true)

                var token = $form.find('#token').val()

                if (token === undefined || token.length > 0) {
                    return
                }

                ev.target.checkValidity()
                ev.preventDefault()

                $form.find('.has-error').removeClass('has-error')
                var code = $couponCode.val().toLowerCase()
                var country = $form.find('#country').val()
                var vatRegNo = $form.find('#vatRegNo').val()
                var euCountries = [
                    'AT',
                    'BE',
                    'BG',
                    'CY',
                    'CZ',
                    'DK',
                    'EE',
                    'ES',
                    'FI',
                    'FR',
                    'GR',
                    'HR',
                    'HU',
                    'IE',
                    'IT',
                    'LV',
                    'LT',
                    'LU',
                    'MT',
                    'NL',
                    'PT',
                    'RO',
                    'SE',
                    'SI',
                    'SK',
                ]

                // Check if EU customer has VAT Reg No set
                if (euCountries.indexOf(country) != -1 && vatRegNo.trim().length == 0 && code != 'nonprofit19jzu') {
                    showError('As a customer from the European Union you must enter a EU-VAT Registration number.', false)
                    return
                }

                if (code.length > 0 && !validCode) {
                    showError('Invalid coupon code given.', false)
                    return
                }

                var url = $form.data('payment-callback-url')
                var displayThreeDSecure = function(actionTokenId) {
                    var threeDSecureContainer = document.querySelector('.three-d-secure-auth-container')
                    var formContainer = document.querySelector('#paymentform')
                    var risk = recurly.Risk()
                    var threeDSecure = risk.ThreeDSecure({ actionTokenId: actionTokenId })
                    threeDSecure.on('error', function(err) {
                        // Handle errors that occur during 3-D Secure authentication
                        $form
                            .find('.three-d-secure-auth-container')
                            .prepend('<a href="' + url + '" class="btn btn-primary btn-lg">Back to Checkout</a>')
                        showError(err, true)
                    })
                    threeDSecure.on('token', function(token) {
                        $form.find('#three-d-secure-token').val(token.id)
                        // Hide the container once we have a token
                        threeDSecureContainer.style.display = 'none'
                        form.submit()
                    })

                    threeDSecure.attach(threeDSecureContainer)
                    $form.find('#signup').attr('disabled', true)
                    formContainer.style.display = 'none'
                    // Show the container
                    threeDSecureContainer.style.display = 'block'
                }

                recurly.token(form, function(err, token) {
                    if (err) {
                        var message
                        switch (err.code) {
                            case 'validation':
                            case 'invalid-parameter':
                                if (err.message.indexOf('VIES VAT number validation service unavailable') > 0) {
                                    message =
                                        'The European Union VAT number validation service is unavailable. ' +
                                        'Sadly, this happens regularly, but we are legally required to check it. ' +
                                        'Please try subscribing again later.'
                                } else {
                                    for (var i = 0; i < err.fields.length; i++) {
                                        $('[data-recurly="' + err.fields[i] + '"]')
                                            .parents('.form-group')
                                            .addClass('has-error')
                                            .focus()
                                    }
                                    message = 'Some fields (' + err.fields.join(', ') + ') contain invalid data. Please correct them.'
                                }
                                break
                            default:
                                Raven.captureException(new Error('Recurly error: ' + JSON.stringify(err)))

                                message = '[1]Payment Gateway Error. Please contact support@tideways.com for help!'
                                break
                        }
                        showError(message, false)
                        return
                    }
                    $form.find('#token').val(token.id)
                    $.ajax({
                        url: 'checkout',
                        type: 'POST',
                        data: $form.serialize(),
                        dataType: 'json',
                        error: function() {
                            showError('[2]Payment Gateway Error. Please contact support@tideways.com for help!', false)
                        },
                        success: function(response) {
                            // For no SCA-Flow
                            if (response.success === true) {
                                $(location).attr('href', url)
                            }
                            if (response.error) {
                                showError(response.error)
                                if (response.three_d_secure_action_token_id) {
                                    displayThreeDSecure(response.three_d_secure_action_token_id)
                                }
                            }
                        },
                    })
                })
            })
        })
    }
    jQuery.fn.paymentSignup.defaults = {}
})(jQuery, jQuery)

// data-remote-modal
//     2: ./Bundle/ProfilerBundle/Resources/views/Transaction/list.html.twig
//     1: ./Bundle/AlertBundle/Resources/views/ActionConfiguration/action-view.html.twig
//     1: ./Bundle/AlertBundle/Resources/views/ActionConfiguration/index.html.twig
//     1: ./Bundle/AlertBundle/Resources/views/Configuration/viewCheck.html.twig
//     1: ./Bundle/AlertBundle/Resources/views/Configuration/index.html.twig
;(function($, jQuery) {
    jQuery.fn.remoteModal = function(options) {
        options = jQuery.extend({}, jQuery.fn.remoteModal.defaults, options)

        return $(this).each(function() {
            var $el = $(this)
            var idClass = $(this).data('remote-modal') || '#help-modal'
            $el.on('click', function(ev) {
                ev.preventDefault()

                $.ajax({
                    url: $el.attr('href'),
                    success: function(data) {
                        var $modal = $(idClass)
                            .html(data)
                            .modal('show')
                        initEvents($modal)
                    },
                })
            })
        })
    }
    jQuery.fn.remoteModal.defaults = {}
})(jQuery, jQuery)
;(function($, jQuery) {
    jQuery.fn.radioRow = function() {
        return $(this).each(function() {
            $(this).css({ cursor: 'pointer' })
            $(this).click(function(event) {
                if (event.target.type !== 'radio') {
                    $(':radio', this).trigger('click')
                }
            })
        })
    }
})(jQuery, jQuery)

// data-clipboard-copy
//      1. /Bundle/OrganizationBundle/Resources/views/Admin/showOrganization.html.twig
;(function($, jQuery) {
    function clipboardApiAvailable() {
        return navigator.clipboard && typeof navigator.clipboard.writeText !== 'undefined'
    }

    function clipboardIconChange(target) {
        // Change clipboard icon to checkmark for 6 seconds

        if (target.classList.contains('fa-clipboard')) {
            target.classList.remove('fa-clipboard')
            target.classList.add('fa-check')
            setTimeout(function() {
                target.classList.remove('fa-check')
                target.classList.add('fa-clipboard')
            }, 6000)
        } else if (target.innerHTML === 'Copy URL') {
            target.innerHTML = 'Copied'
            setTimeout(function() {
                target.innerHTML = 'Copy URL'
            }, 6000)
        }
    }

    jQuery.fn.clipboardCopy = function() {
        return $(this).each(function() {
            if (!clipboardApiAvailable()) {
                $(this).hide()
            }

            $(this).click(function(ev) {
                var element = $(this).attr('data-clipboard-copy')
                clipboardIconChange(ev.target)

                var input = $('#' + element).val() || $('#' + element).text()
                navigator.clipboard.writeText(input.trim())
                ev.preventDefault()
            })
        })
    }
})(jQuery, jQuery)

// data-transaction-selector
//    1: ./Bundle/ProfilerBundle/Resources/views/Transaction/list.html.twig
;(function($, jQuery) {
    $('#transaction-multi-select').change(function(e) {
        $('[data-transaction-selector]').prop('checked', e.target.checked)
        updateBulkActionDropdownStatus()
    })

    function updateBulkActionDropdownStatus() {
        $('.js-bulk-dropdown').prop('disabled', $('[data-transaction-selector]:checked').length === 0)
    }

    jQuery.fn.enableChangeVisibilityButton = function() {
        // On navigating back, the browser restores the selection status of the checkboxes.
        // Unfortunately the browser restores the status after the document is ready.
        // That's why we have to use setTimeout here.
        setTimeout(updateBulkActionDropdownStatus, 0)
        return $(this).change(updateBulkActionDropdownStatus)
    }
})(jQuery, jQuery)
;(function($, jQuery) {
    function submitBulkVisibilityChange(e) {
        e.preventDefault()
        let $form = $('#change-visibility-form')
        let targetVisibility = e.target.getAttribute('data-target-visibility')

        $form.find('input[name="targetVisibility"]').attr('value', targetVisibility)
        $form.attr('action', $form.attr('data-action-visibilityChange'))
        $form.submit()
    }

    jQuery.fn.handleBulkVisibilityChange = function() {
        return $(this).click(submitBulkVisibilityChange)
    }
})(jQuery, jQuery)
;(function($, jQuery) {
    function submitBulkFailureNotificationCategoryChange(e) {
        e.preventDefault()
        let $form = $('#change-visibility-form')
        let targetFailureNotificationCategory = e.target.getAttribute('data-target-failure-notification-category')

        $form.find('input[name="targetFailureNotificationCategory"]').attr('value', targetFailureNotificationCategory)
        $form.attr('action', $form.attr('data-action-failureNotificationCategory'))
        $form.submit()
    }

    jQuery.fn.handleBulkFailureNotificationCategoryChange = function() {
        return $(this).click(submitBulkFailureNotificationCategoryChange)
    }
})(jQuery, jQuery)
;(function($, jQuery) {
    jQuery.fn.installSelector = function(options) {
        options = jQuery.extend({}, jQuery.fn.installSelector.defaults, options)

        var testSelectorElementMatches = function(expectedSelector) {
            return function(index) {
                var actualSelector = $(this).closest('[data-install-selector]')
                return actualSelector[0] == expectedSelector[0]
            }
        }

        return $(this).each(function() {
            var $selector = $(this)
            var test = testSelectorElementMatches($selector)
            var currentType = $(this).data('install-selector')
            var $buttons = $(this)
                .find('[data-install-selector-type]')
                .filter(test)
            var $helps = $(this)
                .find('[data-install-selector-help]')
                .filter(test)

            $buttons.on('click', function(ev) {
                ev.preventDefault()
                let target = ev.target
                while (!$(target).data('install-selector-type')) {
                    target = target.parentNode
                    if (!target) {
                        return
                    }
                }

                $buttons
                    .filter('[data-install-selector-type="' + currentType + '"]')
                    .removeClass('btn-primary')
                    .addClass('btn-default')
                $(target)
                    .addClass('btn-primary')
                    .removeClass('btn-default')

                $helps.filter('[data-install-selector-help="' + currentType + '"]').fadeOut(150, function() {
                    currentType = $(target).data('install-selector-type')
                    $helps.filter('[data-install-selector-help="' + currentType + '"]').fadeIn(150)
                })
            })

            $helps.hide()
            $buttons
                .filter('[data-install-selector-type="' + currentType + '"]')
                .addClass('btn-primary')
                .removeClass('btn-default')
            $helps.filter('[data-install-selector-help="' + currentType + '"]').show()
        })
    }
    jQuery.fn.installSelector.defaults = {}
})(jQuery, jQuery)

// data-retention
//     5: ./Bundle/BillingBundle/Resources/views/Billing/show.html.twig
// data-retention-default
//     1: ./Bundle/BillingBundle/Resources/views/Billing/show.html.twig
// data-retention-factor
//     1: ./Bundle/BillingBundle/Resources/views/Billing/show.html.twig
;(function($, jQuery) {
    jQuery.fn.applicationRetention = function(options) {
        options = jQuery.extend({}, jQuery.fn.applicationRetention.defaults, options)

        var factors = { 1: 1, 3: 1.5, 14: 2, 30: 2.5, 90: 3 }

        return $(this).each(function() {
            var retentionElement = $(this)
            var url = $(this).data('retention-url')
            var start = $(this).data('retention-default')

            var retentionButtons = $(this).find('[data-retention]')

            if (typeof factors[start] === 'undefined') {
                start = 1
            }

            retentionButtons.on('click', function(ev) {
                ev.preventDefault()

                retention = parseInt($(ev.target).data('retention'))
                retentionButtons.removeClass('btn-primary').addClass('btn-default')
                $(ev.target)
                    .removeClass('btn-default')
                    .addClass('btn-primary')

                retentionElement.find('span[data-retention-factor]').text(factors[retention].toFixed(1) + 'x')

                $.ajax({
                    url: url,
                    type: 'POST',
                    data: { days: retention },
                    dataType: 'json',
                    success: function(content) {},
                })
            })

            retentionButtons
                .filter('[data-retention="' + start + '"]')
                .removeClass('btn-default')
                .addClass('btn-primary')
            retentionElement.find('span[data-retention-factor]').text(factors[start].toFixed(1) + 'x')
        })
    }
    jQuery.fn.applicationRetention.defaults = {}
})(jQuery, jQuery)
;(function($, jQuery) {
    jQuery.fn.tracesWaitingList = function(options) {
        options = jQuery.extend({}, jQuery.fn.tracesWaitingList.defaults, options)

        return $(this).each(function() {
            var url = $(this).data('traces-waiting')
            var traceEndpointTemplate = $(this).data('traces-waiting-trace-endpoint')
            var panel = $(this)

            var formatMemory = function(memory) {
                return Math.round(memory / 100) / 10 + ' MB'
            }

            var rowTemplate = function(profile) {
                var html = ''

                html += '<a href="' + traceEndpointTemplate.replace('ID', profile.id) + '">'

                html += '<div class="row">'
                html += '<div class="col-md-10">' + profile.operation + '</div>'
                html += '<div class="col-md-2">' + Math.round(profile.wallTime / 100) / 10 + ' ms</div>'
                html += '</div>'
                html += '</a>'

                return html
            }

            var pollForTraces = function() {
                $.ajax({
                    url: url,
                    dataType: 'json',
                    success: function(data) {
                        if (data.length == 0) {
                            setTimeout(pollForTraces, 10000)
                            return
                        }

                        var html = ''
                        for (var idx in data) {
                            html += rowTemplate(data[idx])
                        }

                        panel.html(html)
                    },
                })
            }

            panel.html(
                '<div class="traces-waiting-loading"><img src="/assets/img/loader.gif" /><br /><small>Waiting for the first trace...</small></div>',
            )

            setTimeout(pollForTraces, 1000)
        })
    }
    jQuery.fn.tracesWaitingList.defaults = {}
})(jQuery, jQuery)

// data-confirm-submit
//     6: ./Bundle/BillingBundle/Resources/views/Billing/upgradeLicense.html.twig
//     3: ./Bundle/BillingBundle/Resources/views/Billing/upgrade.html.twig
;(function($, jQuery) {
    jQuery.fn.confirmSubmitButton = function(options) {
        options = jQuery.extend({}, jQuery.fn.confirmSubmitButton.defaults, options)

        return $(this).each(function() {
            var $btn = $(this)
            var modalId = $btn.data('confirm-submit')
            var $form = $btn.parents('form')
            var $modal = $(modalId).clone()
            $('body').append($modal)
            $modal.modal({ show: false })
            $modal.find('.btn-ok').click(function() {
                $modal.modal('hide')
                $form.submit()
                $btn.attr('disabled', 'disabled')
            })

            $(this).on('click', function() {
                $modal.modal('show')
                return false
            })
        })
    }
    jQuery.fn.confirmSubmitButton.defaults = {}
})(jQuery, jQuery)

function date_default_timezone_set(timezone) {
    console.log('Oi! We specifically mentioned *server* timezone.')
    console.log('Nevertheless we grant you this wish and use the Timezone REST API...')

    $.ajax({
        url: '/settings/timezone',
        method: 'POST',
        data: 'timezone=' + timezone,
        dataType: 'json',
        success: function(response) {
            console.log('Response: ' + response.msg)
        },
    })

    return false
}

;(function($, jQuery) {
    jQuery.fn.strongPasswordIndicator = function(options) {
        options = jQuery.extend({}, jQuery.fn.strongPasswordIndicator.defaults, options)

        var strongPasswordUpdate = function(e) {
            var result = zxcvbn($(e.target).val(), options.userData())

            if (result.score < 2) {
                $(options.weakIndicator).html('Weak (requires strength "Good")')
                $(options.button).attr('disabled', true)
            } else {
                $(options.weakIndicator).html('Good')
                $(options.button).attr('disabled', false)
            }
        }

        return $(this).each(function() {
            $(this)
                .on('input', strongPasswordUpdate)
                .trigger('change')
        })
    }
    jQuery.fn.strongPasswordIndicator.defaults = {
        button: 'input[type="submit"]',
        weakIndicator: '#passwordStrengthIndicator',
        userData: function() {
            return []
        },
    }
})(jQuery, jQuery)

$(document).ready(function() {
    initEvents('body')
})
